import React from 'react';
import FlowFunnelView from '../components/FlowFunnelView';
import { GitPullRequest } from 'lucide-react';
import { useTelemetry } from '../context/TelemetryContext';

export default function FunnelsView(props) {
  const telemetry = useTelemetry();
  const mno = props.mno ?? telemetry.mno;
  const route = props.route ?? telemetry.route;
  const forceMock = props.forceMock ?? telemetry.forceMock;

  const benchmarkFlows = [
    { name: 'Balance Enquiry', code: 'BALANCE_ENQUIRY', started: 62400, completed: 56160, conversion: '90.0%', avgHops: 3.0, avgDuration: '6.4s', status: 'Optimal' },
    { name: 'Mini Statement', code: 'MINI_STATEMENT', started: 28900, completed: 25430, conversion: '88.0%', avgHops: 2.0, avgDuration: '5.1s', status: 'Optimal' },
    { name: 'Funds Transfer', code: 'FUNDS_TRANSFER', started: 34200, completed: 24960, conversion: '73.0%', avgHops: 5.0, avgDuration: '14.2s', status: 'Friction at Amount' },
    { name: 'Buy Airtime', code: 'BUY_AIRTIME', started: 18200, completed: 15470, conversion: '85.0%', avgHops: 4.0, avgDuration: '9.8s', status: 'Optimal' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      
      {/* 1. Interactive Visual Flow Funnel */}
      <FlowFunnelView mno={mno} route={route} forceMock={forceMock} />

      {/* 2. Cross-Flow Comparison Matrix */}
      <div className="glass-card" style={{ padding: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
          <GitPullRequest size={18} color="var(--accent-blue)" />
          <h2 style={{ fontSize: '16px', fontWeight: '700' }}>Cross-Service Flow Benchmark Matrix</h2>
        </div>
        <p style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '20px' }}>
          Comparative conversion efficiency, average interaction depth, and friction ratings
        </p>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'left' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border-medium)', color: 'var(--text-muted)' }}>
                <th style={{ padding: '12px 16px' }}>Banking Service Flow</th>
                <th style={{ padding: '12px 16px' }}>Total Started</th>
                <th style={{ padding: '12px 16px' }}>Completed</th>
                <th style={{ padding: '12px 16px' }}>Conversion Rate</th>
                <th style={{ padding: '12px 16px' }}>Avg Depth</th>
                <th style={{ padding: '12px 16px' }}>Avg Duration</th>
                <th style={{ padding: '12px 16px' }}>Friction Assessment</th>
              </tr>
            </thead>
            <tbody>
              {benchmarkFlows.map((flow, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--border-subtle)' }}>
                  <td style={{ padding: '14px 16px', fontWeight: '700', color: 'var(--text-primary)' }}>
                    {flow.name}
                  </td>
                  <td style={{ padding: '14px 16px', color: 'var(--text-secondary)' }}>
                    {flow.started.toLocaleString()}
                  </td>
                  <td style={{ padding: '14px 16px', color: 'var(--accent-emerald)', fontWeight: '600' }}>
                    {flow.completed.toLocaleString()}
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <span style={{
                      fontWeight: '700',
                      color: parseFloat(flow.conversion) >= 85 ? 'var(--accent-emerald)' : 'var(--accent-amber)',
                      background: parseFloat(flow.conversion) >= 85 ? 'rgba(16, 185, 129, 0.12)' : 'rgba(245, 158, 11, 0.12)',
                      padding: '4px 8px',
                      borderRadius: '999px',
                      fontSize: '12px'
                    }}>
                      {flow.conversion}
                    </span>
                  </td>
                  <td style={{ padding: '14px 16px', color: 'var(--text-secondary)' }}>
                    {flow.avgHops} hops
                  </td>
                  <td style={{ padding: '14px 16px', color: 'var(--text-secondary)' }}>
                    {flow.avgDuration}
                  </td>
                  <td style={{ padding: '14px 16px' }}>
                    <span style={{
                      fontSize: '11px',
                      fontWeight: '600',
                      color: flow.status === 'Optimal' ? 'var(--accent-emerald)' : 'var(--accent-rose)',
                      background: flow.status === 'Optimal' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(244, 63, 94, 0.1)',
                      padding: '3px 8px',
                      borderRadius: '4px'
                    }}>
                      {flow.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>

    </div>
  );
}
